import s from './Reasons.module.scss';
import good from '../../assets/images/good.png';
import handshake from '../../assets/images/handshake.png';
import home from '../../assets/images/home.png';
import money from '../../assets/images/money.png';

const Reasons = () => {
  const reasons = [
      {
          image: money,
          title: 'どこよりも低価格保証',
          description: 'オーストラリア・ケアンズで一番価格の自信があります！営業会社を間に挟んでいないので、他社より価格を抑えることが可能です。もし1円でも高ければお気軽ご相談ください！',
      },
      {
          image: handshake,
          title: '対応力がスゴイ',
          description: 'ジェイさんのツアーは政府公認会社でオーストラリアに登録されており、創業20年を超えるJAY&JAY Pty.Ltd.社が運営しています。だからこそ、もしもの時も安心対応です。',
      },
      {
          image: home,
          title: 'アットホームで安心感がスゴイ',
          description: 'ジェイさんツアーでは、現地在住の日本人スタッフがLINEでお客様のお困り事や質問にお答えしております。予約前からどんなご相談にもお答えしますので、お気軽にご相談くださいね！',
      },
      {
          image: good,
          title: 'サービスがスゴイ',
          description: '飛行機の欠便、予約当日にまさかの悪天候、ツアーに行けない・・・でもご安心を！ジェイさんツアーでは雨や悪天候でも代わりのツアーをご用意できます。お気軽にご相談ください。',
      },
  ];

  return (
    <div className={s.root}>
      <div className={s.titleContainer}>
        <div>
          <span>Why Choose Us?</span>
          <h2>ジェイさんツアーが選ばれる理由</h2>
        </div>
      </div>
      <div className={s.container}>
        {reasons.map((reason, index) => (
          <div className={s.card} key={index}>
            <img src={reason.image} alt={reason.title} className={s.icon} />
            <h3>{reason.title}</h3>
            <p>{reason.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reasons;
